// extracted by mini-css-extract-plugin
export default {"spinnerMini":"SpinnerMini_spinnerMini__1GcAM","rotate":"SpinnerMini_rotate__1VFEe"};